<template>
  <div class="ml-3 mt-3" style="width:970px">
	<div class="mb-2">
            <el-form inline ref="form" :model="searchform">
      

                    <el-form-item  class="mb-0">
                         <el-date-picker
                              v-model="searchform.time"
                              type="date"
                              size="mini" class="mr-2"  style="width:200px;" value-format="yyyy-MM-dd">
                            </el-date-picker>
                    </el-form-item>
                    <el-form-item class="mb-0">
                        <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
                    </el-form-item>
            </el-form>
       
         
        
            
            
        </div>
	 <div class="card-body p-0">
                            <table class="table table-striped align-middle table-row-bordered ">
                                <thead>
                                    <tr>
                                        <th>{{$t('tableText.타입')}}</th>
                                         <th>{{$t('tableText.슬롯롤링대기')}}</th>
                                        <th>{{$t('tableText.슬롯베팅')}}</th>
                                        <th>{{$t('tableText.슬롯당첨')}}</th>
                                         <th>{{$t('tableText.카지노롤링대기')}}</th>
                                          <th>{{$t('tableText.카지노타이')}}</th>
                                        <th>{{$t('tableText.카지노베팅')}}</th>
                                        <th>{{$t('tableText.카지노당첨')}}</th>
                                       
                                       
                                       

                                    </tr>
                                </thead>
                                <tbody>
                            <tr  v-for="(item,index) in list2" :key="item.id" :index="index">
                                  <td>HISTORY</td>
                                    <td>{{formatMoney(item.srognull)}}</td>
                                <td>{{formatMoney(item.sbet)}}</td>
                                <td>{{formatMoney(item.swin)}}</td>
                                  <td>{{formatMoney(item.erognull)}}</td>
                                    <td>{{formatMoney(item.etie)}}</td>
                                <td>{{formatMoney(item.ebet)}}</td>
                                <td>{{formatMoney(item.ewin)}}</td>
                              
                              
                             
                            </tr>
                             <tr  v-for="(item,index) in list3" :key="item.id" :index="index">
                                <td>LOGS</td>
                                 <td><span style="color:red">{{formatMoney(item.soso)}}</span></td>
                                 <td>{{formatMoney(item.sbet)}}</td>
                                 <td>{{formatMoney(item.swin)}}</td>
                                  <td></td>
                                   <td><span style="color:red">{{formatMoney(item.caca)}}</span></td>
                                <td>{{formatMoney(item.ebet)}}</td>
                                <td>{{formatMoney(item.ewin)}}</td>
                              
                                
                               
                             
                            </tr>
                        
                        </tbody>
                            </table>
                        </div>
  <el-table
      :data="list1"
       v-loading="loading"
      style="width: 100%"
      border
        show-summary
       :summary-method="getSummaries"
        :row-class-name="tableRowClassName"
       class="mt-2"   :empty-text="$t('tableText.데이타가없습니다')" >
      
           <el-table-column
           align="center"
            prop="ref_txid"
            label="ref_txid"> 
             <template slot-scope="scope">
               <span class="text-primary" style="cursor:pointer" @click="historyCode(scope.row.ref_txid)">{{scope.row.ref_txid}}</span>
             </template>
          </el-table-column>
           <el-table-column
           align="center"
            prop="bb_code"
            label="bb_code"> 
          </el-table-column>
            <el-table-column
           align="center"
            prop="bet"
            label="bet"> 
             <template slot-scope="scope">
                <span  :class="func(scope.row.bet)"> {{ formatMoney(scope.row.bet)}}</span>
             </template>
          </el-table-column>
           <el-table-column
           align="center"
            prop="money"
            label="money"> 
              <template slot-scope="scope">
          <span :class="func(scope.row.money)">   {{ formatMoney(scope.row.money)}}</span>
      </template>
          </el-table-column>
          
      <el-table-column
           align="center"
            prop=""
            label="cc"> 
              <template slot-scope="scope">
          <span  :class="">   {{ formatMoney(parseInt(scope.row.money)+parseInt(scope.row.bet))}}</span>
      </template>
          </el-table-column>
  
     
     <!--  <el-table-column
			prop="contents"
             :label="$t('msg.내용')">
			 <template slot-scope="scope">
            	<el-input
					  type="textarea"
					  :rows="2"
					  v-model="scope.row.contents">
					</el-input>
        	</template>
		  </el-table-column> -->
		  
		  

		 
    </el-table>

    
                    
				

			
</div>
 </template>

 <script>
 import layer from './layer.vue';
import layerNew from './layer-new.vue';
import historyCode from './history-code.vue';
    export default {
     components: {
      layer,layerNew,historyCode
    },
    	data(){
    		return{  
                list1:[],
                list2:[],
                list3:[],
                searchform:{
                    
                    time:'',
                  
            
             
          


                },  
                otp:'',
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
           bg:window.sessionStorage.getItem('bg'),
           userid:window.sessionStorage.getItem('userid'),
            aid:window.sessionStorage.getItem('admin_id'),
    			formLoading:false,
          idDialogVisible: false,
    			total:0,
    			size:0,
    			loading: false,
    			tableData: [],
    			currentPage:1,
			    multipleSelection:[],
			   
   
    			}
	
    		},
    		created() {
    			this.getList();

		},
    	
    	methods:{
    		  // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
             tableRowClassName({row, rowIndex}) {
    
       if (rowIndex%2 === 1) {
        return 'odd-row-class';
       }
       else{
         return 'edd-row-class';
       }
    },
    historyCode(id){
//        if(this.userid!='admin')
//             {
// return;
//             }

              this.$layer.iframe({
            type: 2,
            title: this.$i18n.t("searchText.히스토리"),
            content: {
                content: historyCode,
                parent: this,
                data:{
                    info:{id:id}
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['1000px', '680px'],
         
        });
    },
    func(state){
      if(state > 0){
        return "text-success"
      }else if(state <0){
         return "text-danger"
      }else if(state ===0){
         return ""
      }
    },
     getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
           if(index === 0){
             sums[index] = this.$i18n.t("msg.합계");
          }
    else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
        
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
        cancelData(){
          this.idDialogVisible = false
        },
         openModel(id){

              let pix=window.screen.width;
           
                let width='1200px';
                if(pix<1200)
                {
                  width='95%';
                }
                

           
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                        info:{id:id},
                        layerid:'id',
                        activeTab:'tab1',
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                   area: [width+'', '740px'],
             
             });
              return;
           

        
        },
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
                    searchEvent(){

                if( this.searchform.time == ''){
                     this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                     return;
                }

              
            


                this.getList();
                
             

            },
			     
    		getList(){

    		   
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/history?s_time='+this.searchform.time;
    			
    		
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data)
                     this.list1 =response.data.data.list1
                     this.list2 =response.data.data.list2
                     this.list3 =response.data.data.list3
                     this.total = response.data.data.total
                     this.currentPage = response.data.data.current_page
                     this.size =response.data.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
            	

               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    		
    		
    		handleSelectionChange(val) {
    			//console.log(val)
                this.multipleSelection = val;

      },
    	  // 批量删除
			deleteAll(){
				 this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
					type: 'warning'
				}).then(() => {
					let token=window.sessionStorage.getItem('user');

					//console.log('hh',this.multipleSelection);

                    let newids=[];

					 this.multipleSelection.forEach(item=>{
					 	
					 	console.log('id',item);
					 	newids.push(item.idx);
					 });

					// console.log('newids',newids);

					this.$axios({
			                method:'post',
			                 data:{idx:newids,opt:this.otp},
			                url:this.domain+'/admin/hk_del',
			                'Accept': 'application/json',
			                headers: { 'Authorization': 'Bearer ' + token },
			                
			               
			            }).then((response) =>{ 
			            	
			            	if(response.data.code==200){
			            		this.$message({
					    				message:response.data.msg,
					    				type:'success'
			    					})
			            	}else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
			            	this.getList()
    
			            }).catch((error) =>{
			                console.log(error)       //请求失败返回的数据
			            })
           				
       

    			})

				
			}, 	
    	
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
.el-message-box__wrapper{
     z-index: 4000 !important;
     background:rgba(0,0,0,.4)
  }
  .el-picker-panel,.el-color-picker__panel{
  z-index:12000 !important;
}

</style>


// WEBPACK FOOTER //
// src/components/common/history.vue